import React from 'react'
import ReactDOM from 'react-dom'
import Landing from '../landing/Base'

import 'styles/login.scss'

ReactDOM.render(<Landing />, document.getElementById('landing'))
